module.exports = __webpack_public_path__ + "static/media/Collections-Dining-Experiences-Desktop.573d0448.webp";